<template>
  <div class="index">
    <van-sticky>
      <div class="header">
        <van-search v-model="value" placeholder="请输入搜索关键字" @input="searchInput" />
      </div>

      <van-dropdown-menu>
        <!-- 项目部位筛选 -->
        <van-dropdown-item center title="项目部位" @open="onChangeProject(0)" ref="projectItem">
          <div class="projectList">
            <van-tree-select height="100vw" :items="items" @click-nav="onChange" :main-active-index.sync="active">
              <template #content>
                <div v-if="active === 0">
                  <van-index-bar highlight-color="#108EE9">
                    <div v-for="(item, index) in projectList" :key="index">
                      <van-index-anchor :index="item.length!=0?index:''" />
                      <van-checkbox-group v-model="projectResult" res="checkboxGroup" @change="selectDataOptsChange">
                        <div v-for="(ele, index) in item" clickable :key="ele.projectId" :title="ele.projectName" role="button" :tabindex="index" class="
                      van-cell van-cell--clickable
                      van-dropdown-item__option
                    ">
                          <div class="van-cell__title">
                            <span>
                              <van-checkbox :name="ele.projectId" checked-color="#A9B910">
                                {{ ele.projectName }}
                              </van-checkbox>
                            </span>
                          </div>
                        </div>
                      </van-checkbox-group>
                    </div>
                  </van-index-bar>
                </div>
                <div v-if="active === 1">
                  <van-index-bar highlight-color="#108EE9">
                    <div v-for="(item, index) in positionList" :key="index">
                      <van-index-anchor :index="item.length!=0?index:''" />
                      <van-checkbox-group v-model="positionResult" res="checkboxGroup" @change="selectDataOptsChange">
                        <div v-for="(ele, index) in item" clickable :key="ele.positionId" :title="ele.positionName" role="button" :tabindex="index" class="
                      van-cell van-cell--clickable
                      van-dropdown-item__option
                    ">
                          <div class="van-cell__title">
                            <span>
                              <van-checkbox :name="ele.positionId" checked-color="#A9B910">
                                {{ ele.positionName }}
                              </van-checkbox>
                            </span>
                          </div>
                        </div>
                      </van-checkbox-group>
                    </div>
                  </van-index-bar>
                </div>
              </template>
            </van-tree-select>
          </div>
          <div class="calenderButton">
            <div class="reset" @click="reset(0)">重置</div>
            <div class="caleSure" @click="onConfirm(0)">确认</div>
          </div>
        </van-dropdown-item>
        <!-- 仪器筛选 -->
        <van-dropdown-item center title="仪器" @open="onChangeProject(1)" ref="instrucmentItem">
          <van-index-bar highlight-color="#108EE9">
            <div v-for="(item, index) in instrucmentList" :key="index">
              <van-index-anchor :index="item.length!=0?index:''" />
              <van-checkbox-group v-model="instrucmentResult" res="checkboxGroup" @change="selectDataOptsChange">
                <div v-for="(ele, index) in item" clickable :key="ele.instrumentId" :title="ele.instrumentName" role="button" :tabindex="index" class="van-cell">
                  <div class="van-cell__title">
                    <span>

                      <van-checkbox :name="ele.instrumentId" icon-size="24px" checked-color="#A9B910">
                        {{ ele.instrumentName }}
                      </van-checkbox>
                    </span>
                  </div>
                </div>
              </van-checkbox-group>
            </div>
          </van-index-bar>
          <div class="calenderButton">
            <div class="reset" @click="reset(1)">重置</div>
            <div class="caleSure" @click="onConfirm(1)">确认</div>
          </div>
        </van-dropdown-item>
        <!-- 时间筛选 -->
        <van-dropdown-item title="时间" ref="timeItem">
          <Calendar v-on:choseDay="clickDay" v-on:changeMonth="changeDate" :value="dateValue"></Calendar>
          <div class="calenderButton">
            <div class="reset" @click="reset(3)">重置</div>
            <div class="caleSure" @click="onConfirm(3)">确认</div>
          </div>
        </van-dropdown-item>
        <!-- 操作人筛选 -->
        <van-dropdown-item center title="操作人" @open="onChangeProject(2)" ref="userItem">
          <van-index-bar highlight-color="#108EE9">
            <div v-for="(item, index) in textList" :key="index">
              <van-index-anchor :index="item.length!=0?index:''" />
              <van-checkbox-group v-model="userResult" res="checkboxGroup" @change="selectDataOptsChange">
                <div v-for="(ele, index) in item" clickable :key="ele.doctorId" :title="ele.doctorName" role="button" :tabindex="index" class="van-cell van-cell--clickable van-dropdown-item__option">
                  <div class="van-cell__title">
                    <span>
                      <van-checkbox :name="ele.doctorId" checked-color="#A9B910" label-position="left">
                        {{ ele.doctorName }}
                      </van-checkbox>
                    </span>
                  </div>
                </div>
              </van-checkbox-group>
            </div>
          </van-index-bar>
          <div class="calenderButton">
            <div class="reset" @click="reset(2)">重置</div>
            <div class="caleSure" @click="onConfirm(2)">确认</div>
          </div>
        </van-dropdown-item>
      </van-dropdown-menu>
      <van-tabs v-model="condition" @click="conditionChange">
        <div class="indexInfo">共<span class="count">{{tableData.length}}</span>条信息</div>
        <van-tab title="待完成" aria-label="3" name="3"></van-tab>
        <van-tab title="已完成" aria-label="2" name="2"></van-tab>
        <van-tab title="已取消" aria-label="1" name="1"></van-tab>
      </van-tabs>
    </van-sticky>
    <div v-if="tableData.length!=0">
      <div class="card" v-for="(item, index) in tableData" :key="index" @click="enterDetail(item)">
        <div :class="item.appointStatus=='初诊'?'firstStatus':item.appointStatus=='VIP'?'vip':''">
          <div class="proName">{{ item.projectName }}</div>
          <img src="../assets/img/continue.png" alt="" class="cardImg" v-if="item.operationStatus == 3" />
          <img src="../assets/img/finish.png" alt="" class="cardImg" v-if="item.operationStatus == 2" />
          <img src="../assets/img/cancel.png" alt="" class="cardImg" v-if="item.operationStatus == 1" />
          <div class="concat">
            <div v-if="item.instrumentTime">
              <div v-for="(item,index) in item.instrumentTime.split(',')" :key="index">
                <span>{{item}}</span>
              </div>
            </div>
            <div>
              <span class="concatFirst">{{ item.customerName }}</span>
              <span v-if="item.userId!=empId">{{ item.mobile.replace(item.mobile.substr(3,4), '****') }}</span>
              <span v-if="item.userId==empId">{{ item.mobile}}</span>
            </div>
          </div>
          <div class="concat_name">
            <span>{{ item.appointmentTime }}</span>
            <span><span class="concatFirst">{{item.userName}}</span>{{ item.doctorName }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="indexWhite" v-if="tableData.length==0"><img src="../assets/img/index-white.png" alt=""></div>
  </div>
</template>
<script>
let pinyin = require('js-pinyin');
import completed from "./page/completed.vue";
import Calendar from "vue-calendar-component";
import {
  findByDoctorIdList,
  findByInstrumentIdList,
  findByProjectIdList,
  findByPositionIdList,
  findAppointmentList,
} from "@/axios/api";
export default {
  components: {
    completed,
    Calendar,
  },
  name: 'index',
  data() {
    return {
      value: "",
      condition: 3,
      result: [],
      instrucmentList: [],
      textList: [],
      activeKey: "",
      position: false,
      project: true,
      positionList: [],
      projectList: [],
      // 0待完成1已完成2已取消
      tableData: [],
      empId: "",
      projectResult: [],
      instrucmentResult: [],
      userResult: [],
      positionResult: [],
      dateValue: '',
      offsetTop: '9rem',
      active: 0,
      FirstPin: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "#",
      ],
      items: [{
        text: '项目'
      }, {
        text: '部位'
      }],
      userStatus: '',
      doctorNo: '',
      scrollTop: '',
      cityCode: JSON.parse(localStorage.getItem('userInfo')).cityCode,
    };
  },
  created() {
    this.empId = JSON.parse(localStorage.getItem('userInfo')).empId
    console.log(this.empId)
    this.userStatus = JSON.parse(localStorage.getItem('userInfo')).status
    this.doctorNo = JSON.parse(localStorage.getItem('userInfo')).doctorNo
    if (this.userStatus == 1) {
      this.appointmentList("999999", "", "", "", "", 3, "", 0);
    } else if (this.userStatus == 0) {
      this.appointmentList("", "", "", "", "", 3, "", "");
    }
  },
  methods: {
    // 查看操作人列表
    findDoctorIdList() {
      findByDoctorIdList({
        ids: "",
      })
        .then((res) => {
          console.log(res.data);
          if (res.result == true) {
            var cities = res.data;
            cities.push({
              doctorId: 999999,
              doctorName: "无指定操作人"
            })
            let cityName = {};
            //循环26个字母的数组
            this.FirstPin.forEach(item => {
              cityName[item] = [];
              cities.forEach(el => {
                //对比开头字母是否对应
                let first = pinyin.getFullChars(el.doctorName).substring(0, 1).toUpperCase();
                var regNumber = /\d+/; //验证0-9的任意数字最少出现1次。
                // var regString = /[a-zA-Z]+/; //验证字母
                if (regNumber.test(first) == true) {
                  el.doctorName = el.doctorName.slice(0, 0) + '#' + el.doctorName.slice(0)
                }
                if (first == item) {
                  cityName[item].push(el);
                }
              });
            });
            this.$nextTick(() => {
              this.textList = cityName
            })
          } else {
            this.$toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 查询仪器列表
    findInstrumentIdList() {
      findByInstrumentIdList({
        ids: "",
        cityCode: this.cityCode
      })
        .then((res) => {
          console.log(res.data);
          if (res.result == true) {
            var cities = res.data;
            let cityName = {};
            //循环26个字母的数组
            this.FirstPin.forEach(item => {
              cityName[item] = [];
              cities.forEach(el => {
                //对比开头字母是否对应
                let first = pinyin.getFullChars(el.instrumentName).substring(0, 1).toUpperCase();
                var regNumber = /\d+/; //验证0-9的任意数字最少出现1次。
                // var regString = /[a-zA-Z]+/; //验证字母
                if (regNumber.test(first) == true) {
                  el.instrumentName = el.instrumentName.slice(0, 0) + '#' + el.instrumentName.slice(0)
                }
                if (first == item) {
                  cityName[item].push(el);
                }
              });
            });
            this.$nextTick(() => {
              this.instrucmentList = cityName
            })
          } else {
            this.$toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 查询项目列表
    findProjectList() {
      findByProjectIdList({
        ids: "",
        areaType: localStorage.getItem('areaType'),
        areaCode: localStorage.getItem('areaType'),
        cityCode: this.cityCode,
      })
        .then((res) => {
          console.log(res.data);
          if (res.result == true) {
            var cities = res.data;
            let cityName = {};
            //循环26个字母的数组
            this.FirstPin.forEach(item => {
              cityName[item] = [];
              cities.forEach(el => {
                //对比开头字母是否对应
                let first = pinyin.getFullChars(el.projectName).substring(0, 1).toUpperCase();
                var regNumber = /\d+/; //验证0-9的任意数字最少出现1次。
                // var regString = /[a-zA-Z]+/; //验证字母
                if (regNumber.test(first) == true) {
                  el.projectName = el.projectName.slice(0, 0) + '#' + el.projectName.slice(0)
                }
                if (first == item) {
                  cityName[item].push(el);
                }
              });
            });
            console.log(cityName)
            this.$nextTick(() => {
              this.projectList = cityName
            })
          } else {
            this.$toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 查询部位列表
    findPositionList() {
      findByPositionIdList({
        ids: "",
      })
        .then((res) => {
          console.log(res.data);
          if (res.result == true) {
            var cities = res.data;
            let cityName = {};
            //循环26个字母的数组
            this.FirstPin.forEach(item => {
              cityName[item] = [];
              cities.forEach(el => {
                //对比开头字母是否对应
                let first = pinyin.getFullChars(el.positionName).substring(0, 1).toUpperCase();
                var regNumber = /\d+/; //验证0-9的任意数字最少出现1次。
                // var regString = /[a-zA-Z]+/; //验证字母
                if (regNumber.test(first) == true) {
                  el.positionName = el.positionName.slice(0, 0) + '#' + el.positionName.slice(0)
                }
                if (first == item) {
                  cityName[item].push(el);
                }
              });
            });
            this.$nextTick(() => {
              this.positionList = cityName
            })
          } else {
            this.$toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    selectDataOptsChange(data) {
      // console.log(data)
    },
    onConfirm(val) {
      let projectResultStr = this.projectResult.toString()
      let instrucmentStr = this.instrucmentResult.toString()
      let userResultStr = this.userResult.toString()
      let positionResultStr = this.positionResult.toString()
      if (val == 0) {
        this.$refs.projectItem.toggle();
      } else if (val == 1) {
        this.$refs.instrucmentItem.toggle();
      } else if (val == 2) {
        this.$refs.userItem.toggle();
      } else if (val == 3) {
        this.$refs.timeItem.toggle();
      }
      if (this.userStatus == 1) {
        console.log(userResultStr)
        if (userResultStr == '') {
          // console.log('没有筛选操作人')
          this.appointmentList("999999", instrucmentStr, projectResultStr, positionResultStr, this.dateValue, this.condition, "", 0)
        } else if (userResultStr != '') {
          // console.log('筛选了操作人')
          this.appointmentList(userResultStr, instrucmentStr, projectResultStr, positionResultStr, this.dateValue, this.condition, "", 1)
        }
      } else if (this.userStatus == 0) {
        this.appointmentList(userResultStr, instrucmentStr, projectResultStr, positionResultStr, this.dateValue, this.condition, "", "")
      }
    },
    clickDay(data) {
      console.log(data); //选中某天
      this.dateValue = data
    },
    changeDate(data) {
      console.log(data); //左右点击切换月份
    },
    clickToday(data) {
      console.log(data); //跳到了本月
    },
    toggle(index) {
      console.log(index);
      // this.$refs.checkboxes[index].toggle();
      console.log(this.result);
      console.log(this.$refs.checkboxes[index]);
    },
    onChange(val) {
      console.log(val);
      if (val == 0) {
        this.position = false;
        this.project = true;
        // this.positionResult = [];
        this.findProjectList()
      } else if (val == 1) {
        this.position = true;
        this.project = false;
        // this.projectResult = [];
        this.findPositionList()
      }
    },
    onChangeProject(val) {
      if (val == 0) {
        this.active = 0
        this.findProjectList()
      } else if (val == 1) {
        this.findInstrumentIdList();
      } else if (val == 2) {
        console.log(this.result);
        this.findDoctorIdList();
      }
    },
    conditionChange(val, title) {
      // console.log('val')
      this.projectResult = [];
      this.positionResult = [];
      this.instrucmentResult = [];
      this.userResult = [];
      if (this.userStatus == 1) {
        this.appointmentList("999999", "", "", "", "", val, this.value, 0);
      } else if (this.userStatus == 0) {
        this.appointmentList("", "", "", "", "", val, this.value, "");
      }
    },
    // 点击进入详情页
    enterDetail(item) {
      console.log(item);
      this.$router.push({
        name: "appointDetail",
        query: item,
      });
    },
    // 查询预约列表
    appointmentList(
      doctorId,
      instrumentId,
      projectId,
      positionId,
      appointmentTime,
      operationStatus,
      name,
      changeStatus
    ) {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "努力加载中..."
      });
      findAppointmentList({
        doctorId: doctorId,
        instrumentId: instrumentId,
        projectId: projectId,
        positionId: positionId,
        appointmentTime: appointmentTime,
        operationStatus: operationStatus,
        // userId: this.empId,
        name: name,
        changeStatus: changeStatus,//医生登录需要，操作人登录不需要,
        userStatus: this.userStatus,
        doctorNo: this.doctorNo,
        areaType: localStorage.getItem('areaType'),
        areaCode: localStorage.getItem('areaType'),
      })
        .then((res) => {
          if (res.result == true) {
            this.tableData = res.data;
            this.$toast.clear();
          } else {
            this.$toast.clear();
            this.$toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          this.$toast.clear()
          console.log(err);
        });
    },
    reset(val) {
      if (val == 0) {
        this.projectResult = [];
        this.positionResult = [];
      } else if (val == 1) {
        this.instrucmentResult = [];
      } else if (val == 2) {
        this.userResult = [];
      }
    },
    // 关键字查询
    searchInput(val) {
      if (this.userStatus == 1) {
        this.appointmentList('', '', '', '', '', this.condition, this.value, 0)
      } else if (this.userStatus == 0) {
        this.appointmentList('', '', '', '', '', this.condition, this.value, "")
      }
    }
  },
  //A>B>C  A>B刷新 C>B不刷新
  beforeRouteLeave(to, from, next) {
    if (to.name === 'appointDetail') {
      from.meta.keepAlive = true;
      // console.log(from.meta.keepAlive)
    } else {
      from.meta.keepAlive = false;
      from.meta.ifDoFresh = true;
    }
    this.scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop
    document.documentElement.scrollTop || document.body.scrollTop
    next(); //不可缺少
  },
  //进入该页面时，用之前保存的滚动位置赋值
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // document.body.scrollTop = vm.scrollTop
      window.scrollTo(0, vm.scrollTop);
    })
    next()
  },

  activated() {
    //开启了keepAlive:true后再次进入,这样就能得到最新数据
    if (this.$route.meta.ifDoFresh) {
      //重置ifDoFresh
      this.$route.meta.ifDoFresh = false;
      // 在数据变化后重新获取参数
      this.empId = JSON.parse(localStorage.getItem('userInfo')).empId
      this.userStatus = JSON.parse(localStorage.getItem('userInfo')).status
      this.doctorNo = JSON.parse(localStorage.getItem('userInfo')).doctorNo
      //获取列表数据方法第一参数为是否重置搜索条件和页数
      // this.condition = 3
      if (this.userStatus == 1) {
        this.appointmentList("", "", "", "", "", this.condition, "", 0);
      } else if (this.userStatus == 0) {
        this.appointmentList("", "", "", "", "", this.condition, "", "");
      }
    }
  },
};

</script>
<style scoped>
@import "../assets/css/index.css";
@import "../assets/css/completed.css";

.index >>> .van-index-bar__index {
  /* color: #108EE9; */
  font-size: 0.6em;
}

.index >>> .van-dropdown-menu__title--active {
  font-size: 1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #0164a8;
}

.index >>> .van-checkbox__icon--checked .van-icon {
  background-color: #ffffff !important;
  color: #108ee9 !important;
  width: 1.31rem;
  border: none;
  height: 1.31rem;
}

.index >>> .van-checkbox__icon .van-icon {
  border: none;
  position: absolute;
  right: 3.5rem;
}

.index >>> .van-checkbox__label {
  margin-left: 1rem !important;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #777777;
}

.index >>> .van-checkbox__icon .van-checkbox__icon--checked {
  color: #108ee9 !important;
}

.index >>> .van-sidebar-item--select::before {
  background: none;
}

.index >>> .van-sidebar-item--select,
.van-sidebar-item--select:active {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #0164a8;
  background: #ffffff;
  box-shadow: 0px 2px 2px -1px #edf0f1;
}

.index >>> .van-tree-select__nav {
  background: #f5f7f9;
}
.firstStatus {
  color: #f56c6c !important;
}
.vip {
  color: #1b84ed !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue